import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from '@ponder-core/auth/auth.interceptor';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
        provideRouter(
          routes, 
          withInMemoryScrolling({ anchorScrolling: "enabled", scrollPositionRestoration: "enabled", }), 
          withComponentInputBinding()), 
        provideClientHydration(), 
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideNgxStripe(environment.stripe.publicKey),
        provideCharts(withDefaultRegisterables()), 
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, 
    ]
};